import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../Actions";
import Tile from "../Layout/Tile";

class CompanyAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {companyStore: { alert: { add } } } = this.props;
        if(add && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }


    render = () => {
        const { companyStore: { alert: { add } }, modalStore: { add: { modal }}, toggleModal } = this.props;
        const { addCompany } = this.props;
        const data = { status: 1 };
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("companies","add")}>
                    <ModalHeader toggle={() => toggleModal("companies","add")}>Add Company</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data={data} persist={addCompany} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    companyStore: state.companyStore,
    modalStore: state.modalStore.companies,
});

const { companies, modals } = Actions; 

export default connect(mapStateToProps, { ...companies, ...modals })(CompanyAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Companies/Add.js